import React from 'react';
import { useTranslations } from 'next-intl';

import { AuthGraphic, type TAuthGraphicVariant } from './auth-graphic';

interface IRightPanelProps {
  titleKey?: string;
  descriptionKey?: string;
  imageAlt?: string;
  graphicVariant?: TAuthGraphicVariant;
  translationNamespace?: string;
}

export const RightPanel: React.FC<IRightPanelProps> = ({
  titleKey = 'welcome_title',
  descriptionKey = 'welcome_description',
  imageAlt = 'Authentication illustration',
  graphicVariant = 'login',
  translationNamespace = 'Auth.register',
}) => {
  const t = useTranslations(translationNamespace);

  return (
    <div className="auth-aside">
      <div className="auth-aside-panel">
        <div className="space-y-6 text-white">
          <h2 className="auth-aside-title">{t(titleKey)}</h2>
          <p className="auth-aside-copy">{t(descriptionKey)}</p>
        </div>
        <AuthGraphic variant={graphicVariant} label={imageAlt} />
      </div>
    </div>
  );
};
